import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CheckCircle2, AlertCircle, Loader2 } from 'lucide-react';
import { completarLoginMagicLink } from '../services/authService';
import styles from './MagicLinkCallbackPage.module.css';

type Status = 'loading' | 'success' | 'error';

export default function MagicLinkCallbackPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<Status>('loading');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    async function completar() {
      try {
        const user = await completarLoginMagicLink();
        if (!user) {
          setStatus('error');
          setErrorMsg('El enlace es invalido o ha expirado.');
          return;
        }
        setStatus('success');
        setTimeout(() => navigate('/salas', { replace: true }), 1500);
      } catch {
        setStatus('error');
        setErrorMsg('No se pudo completar el inicio de sesion. El enlace puede haber expirado.');
      }
    }
    completar();
  }, [navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <img className={styles.brandLogo} src="/minsalud-logo.png" alt="MINSAlud — Portal del Paciente" />
        </div>

        {status === 'loading' && (
          <>
            <Loader2 size={40} className={styles.spinner} />
            <h2 className={styles.title}>Verificando enlace de acceso...</h2>
            <p className={styles.text}>Espere un momento mientras confirmamos su identidad.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle2 size={48} className={styles.successIcon} />
            <h2 className={styles.title}>Sesion iniciada</h2>
            <p className={styles.text}>Redirigiendo a su sala de consulta...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <AlertCircle size={48} className={styles.errorIcon} />
            <h2 className={styles.title}>Enlace invalido</h2>
            <p className={styles.text}>{errorMsg}</p>
            <Link to="/" className={styles.link}>Volver al inicio de sesion</Link>
          </>
        )}
      </div>
    </div>
  );
}
